function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { createConsumer } from "@rails/actioncable";
var consumer = createConsumer();
export default {
  data: function data() {
    return {
      _wsSocket: null
    };
  },
  methods: {
    $wsInitActionCable: function $wsInitActionCable(spec) {
      var component = this;
      Utils.type.ifObject(spec, function (ws) {
        var channelName = ws.channel;
        var subscription = Object.assign({}, ws.params, {
          channel: channelName
        });
        console.log("Connecting to channel", subscription);
        consumer.subscriptions.create(subscription, {
          connected: function connected() {
            var ws = window.vueApp.actionCable;
            ws.channels[channelName] = this;
            console.log("Connected to channel", channelName);
          },
          disconnected: function disconnected() {},
          received: function received(data) {
            var action = data.action;

            var payload = _objectSpread(_objectSpread({}, action), {}, {
              filterKey: ws.filterKey
            });

            if (ws.filterKey === data.filterKey) {
              GLib.action.execute(payload, component);
            }
          }
        });
      }, function () {// this._wsDisconnectSocket();
      });
    }
  }
};